import React from 'react';
import ItemModel from "../../../../../model2/item/item-model";

type Props ={
    item            : ItemModel

    // renderMode      : string
    className?      : string
}

export default function renderListView(props:Props) {

    const noValue = !props.item.calculatedAttachments.total // also 0

    const classes = Classes('flex-row-center-center h-100-percent', 'ui5-txt-less-important-small', props.className, {
        'not-set': noValue
    });

    if (noValue) {
        return <div className={classes} />
    }

    if (props.item.isProject) {

        if (props.item.isCollapsed) {
            return <div className={classes}>
                <div className="estimate-icon ui5-ico-12 i5-summary-symbol m-r-5"/>
                {/*<div className="ui5-ico-13 i5-attachment m-r-5" />*/}
                {props.item.calculatedAttachments.total}
            </div>
        }

        // project doesn't have it's own attachments based on current implementation
        return null
    }

    if (props.item.isTask) {

        if (props.item.isCollapsed) {

            // parent task with subtasks
            if (props.item.calculatedAttachments.children) {
                return <div className={classes}>
                    <div className="estimate-icon ui5-ico-12 i5-summary-symbol m-r-5"/>
                    {/*<div className="ui5-ico-13 i5-attachment m-r-5" />*/}
                    {props.item.calculatedAttachments.total}
                </div>
            } else {
                return <div className={classes}>
                    <div className="ui5-ico-13 i5-attachment m-r-5" />
                    {props.item.calculatedAttachments.total}
                </div>
            }


        }


        return <div className={classes}>
            <div className="ui5-ico-13 i5-attachment m-r-5" />
            {props.item.calculatedAttachments.own}
        </div>
    }

    return null
}